import { connect } from 'react-redux';
import withImmutablePropsToJS from 'with-immutable-props-to-js';

import { Instances } from '../../../constants';
import { DeliveryStatusFilterType } from '../../../interface';
import { IStateType } from '../../../store/models/root.interface';
import {
	changeFilters,
	changeSearchStr,
	requestObjects,
} from '../../../store/Objects';
import {
	makeSelectObject,
	makeSelectFilters,
	changeFilters as objectChangeFilter,
	requestObject,
	makeSelectInProgress
} from '../../../store/Object';

import DeliveryStatus, {
	MapStateType,
	DispatchPropsType,
} from '../organisms/DeliveryStatus/SeeMore';
import { BaseSeeMorePropsType } from '../templates/SeeMoreModal';

const mapStateToProps = (state: IStateType) => ({
	deliveryStatus: makeSelectObject(Instances.deliveryStatus)(state) || {},
	filters: makeSelectFilters(Instances.deliveryStatus)(state),
	inProgress: makeSelectInProgress(Instances.deliveryStatus)(state),
	inProgressTabular: makeSelectInProgress(Instances.deliveryStatusDetailed)(state),
});

const mapDispatchToProps = (dispatch: any) => ({
	onFilter: (filters: DeliveryStatusFilterType) => {
		dispatch(objectChangeFilter(Instances.deliveryStatus, filters));
		dispatch(changeFilters(Instances.deliveryStatusDetailed, filters));
	},
	onSearchChange: (searchStr: string = '') =>
		dispatch(changeSearchStr(Instances.deliveryStatusDetailed, searchStr)),
	onLoad: (filters: DeliveryStatusFilterType) => {
		dispatch(requestObject(Instances.deliveryStatus, undefined, filters));
		dispatch(
			requestObjects(Instances.deliveryStatusDetailed, filters, {
				property: 'status',
			})
		);
	},
});

export default connect<
	MapStateType,
	DispatchPropsType,
	BaseSeeMorePropsType,
	IStateType
>(
	mapStateToProps,
	mapDispatchToProps
)(withImmutablePropsToJS(DeliveryStatus));
